class FirstOrderPopup extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'nicelee-first-order-popup';
    this.delayMs = Number(this.dataset.delay || 3) * 1000;
    this.closeButton = this.querySelector('[data-close-popup]');
    this.overlay = this.querySelector('[data-popup-overlay]');
    this.form = this.querySelector('#FirstOrderPopupForm');
    this.formView = this.querySelector('[data-popup-form]');
    this.successView = this.querySelector('[data-popup-success]');
    this.homePath = this.getHomePath();

    this.form?.addEventListener('submit', () => this.markSubmitted());
    this.closeButton?.addEventListener('click', () => this.hide(true));
    this.overlay?.addEventListener('click', () => this.hide(true));

    const isSuccessRedirect = this.isSuccessRedirect();

    if (isSuccessRedirect) {
      if (window.location.pathname !== this.homePath) {
        window.location.replace(`${this.dataset.homePath}?customer_posted=true`);
        return;
      }

      this.scrollToTop();
      this.markSubmitted();
      this.showSuccess();
      this.show();
      this.cleanSuccessUrl();
      return;
    }

    if (this.hasFormErrors()) {
      this.show();
      return;
    }

    if (this.shouldSkipAutoShow()) return;

    this.timeout = window.setTimeout(() => {
      if (!this.shouldSkipAutoShow()) this.show();
    }, this.delayMs);
  }

  disconnectedCallback() {
    if (this.timeout) window.clearTimeout(this.timeout);
  }

  getHomePath() {
    try {
      return new URL(this.dataset.homePath || '/', window.location.origin).pathname;
    } catch (error) {
      return '/';
    }
  }

  scrollToTop() {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }

  isSuccessRedirect() {
    const params = new URLSearchParams(window.location.search);
    return params.get('customer_posted') === 'true';
  }

  hasFormErrors() {
    return Boolean(this.querySelector('#FirstOrderPopupError'));
  }

  markSubmitted() {
    try {
      localStorage.setItem(this.storageKey, 'submitted');
      sessionStorage.setItem(this.storageKey, 'submitted');
    } catch (error) {
      /* Ignore storage errors in private browsing */
    }
  }

  markDismissed() {
    try {
      localStorage.setItem(this.storageKey, 'dismissed');
      sessionStorage.setItem(this.storageKey, 'dismissed');
    } catch (error) {
      /* Ignore storage errors in private browsing */
    }
  }

  getStoredStatus() {
    try {
      return localStorage.getItem(this.storageKey) || sessionStorage.getItem(this.storageKey);
    } catch (error) {
      return sessionStorage.getItem(this.storageKey);
    }
  }

  shouldSkipAutoShow() {
    if (window.Shopify?.designMode) return false;
    const status = this.getStoredStatus();
    return status === 'submitted' || status === 'dismissed';
  }

  showSuccess() {
    this.formView?.setAttribute('hidden', '');
    this.successView?.removeAttribute('hidden');
  }

  show() {
    this.hidden = false;
    document.body.classList.add('overflow-hidden');
  }

  hide(persist = false) {
    this.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (persist) this.markDismissed();
  }

  cleanSuccessUrl() {
    if (!window.history.replaceState) return;

    const url = new URL(window.location.href);
    url.searchParams.delete('customer_posted');
    window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
  }
}

customElements.define('first-order-popup', FirstOrderPopup);
